import { Box, Container, Grid, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import CustomSelectField from '../formFields/selectField';
import { GET_ALL_BANKS } from 'src/apiService/apiDeclaration';
import CustomLoader from '../loader/loader';
import usePagination from 'src/hooks/usePagination';
import { t } from 'i18next';

const BanksModal = () => {
  const [selectedBank, setSelectedBank] = useState('');
  const { loading, data } = usePagination(GET_ALL_BANKS);
  const [optionsArray, setOptionsArray] = useState([]);

  useEffect(() => {
    if (data) {
      setOptionsArray(data?.rows.map((item, index) => ({ label: item.bankName, value: index })));
    }
  }, [data]);

  return (
    <Container sx={{ width: { sm: ' 400px', xs: '250px' }, minHeight: '360px' }}>
      {loading ? (
        <Box sx={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <CustomLoader />
        </Box>
      ) : (
        <Grid xs={12}>
          <CustomSelectField
            label={t('bankDetails.chooseBank')}
            onChange={(e) => setSelectedBank(e.target.value)}
            shouldTranslate={false}
            optionsArray={optionsArray}
          />
        </Grid>
      )}
      {selectedBank !== '' && (
        <Grid item sx={{ display: 'flex', flexDirection: 'column', gap: 4, my: 4 }}>
          <Typography variant="h6">
            <span style={{ color: '#acd629' }}>{t('bankDetails.bankName')}:</span> {data.rows[selectedBank].bankName}
          </Typography>
          <Typography variant="h6">
            <span style={{ color: '#acd629' }}>{t('bankDetails.AccName')}: </span>
            {data.rows[selectedBank].accountName}
          </Typography>
          <Typography variant="h6">
            <span style={{ color: '#acd629' }}>{t('bankDetails.AccNo')}: </span>
            {data.rows[selectedBank].accountNumber}
          </Typography>
        </Grid>
      )}
    </Container>
  );
};

export default BanksModal;
